export const salonjobsUrl = () => "/salons";

export const salonjobsSalonUrl = (salonId: string | number) =>
  `${salonjobsUrl()}/${salonId}`;

export const salonjobsRedirectUrl = (to: "hairbook" | "instagram", salonId: string | number) =>
  `${salonjobsUrl()}/redirect?to=${to}&salon_id=${salonId}`;
